import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { questionModel } from '../../../Interfaces/questionModel';
import { useCreateQuestionMutation, useGetDropdownListQuery, useUpdateQuestionMutation } from '../../../API/QuestionApi';
import apiResponse from '../../../Interfaces/apiResponse';
import { toast } from 'react-toastify';
import Loader from '../../../Helper/Loader';
import { categoryModel } from '../../../Interfaces/categoryModel';
import { strict } from 'assert';
import QApiResponse from '../../../Interfaces/qApiResponse';
import ImageSrc from '../../../Helper/ImageSrc';

import baseUrlPathImage from '../../../API/baseUrlPathImage';

function QuestionEdit() {
   const{data, isLoading} = useGetDropdownListQuery(null);
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { dataQuestion: questionModel } | undefined;
  const dataQuestion = state?.dataQuestion;
  const [updateQuestion] = useUpdateQuestionMutation();
  const [addQuestion] = useCreateQuestionMutation();
  const [loading, setLoading] =useState(false);
  const [getToast, setGetToast] =useState("Updated");
  const[categories, setCategories] = useState<categoryModel[]>([]);
    useEffect(() =>{
        setLoading(true);
        if(data?.result != null){
            setCategories(data.result);
            //console.log(data.result);
        }
        setLoading(false);
        //console.log(data.result);
    },[data])

    const handleImageDelete = async () => {
        setInput(prev =>({
          ...prev,
          questionImage : null,
        }))
    }
    const handleImageUrlDelete = async () => {
        setGetImageUrl(prev => ({
            ...prev,
            questionImageUrl : null,
        }))
    }

  const [getImageUrl, setGetImageUrl] = useState({
    questionImageUrl:dataQuestion?.questionImageUrl != "" ? `${baseUrlPathImage.test}/${dataQuestion?.questionImageUrl}` :null,
    answerKeyImageUrl:dataQuestion?.answerKeyImageUrl != "" ? `${baseUrlPathImage.test}/${dataQuestion?.answerKeyImageUrl}`:null,
    choiceAImageUrl:dataQuestion?.choice?.choiceAImageUrl != null ? `${baseUrlPathImage.test}/${dataQuestion?.choice?.choiceAImageUrl}`:null,
    choiceBImageUrl:dataQuestion?.choice?.choiceBImageUrl != null ? `${baseUrlPathImage.test}/${dataQuestion?.choice?.choiceBImageUrl}`:null,
    choiceCImageUrl:dataQuestion?.choice?.choiceCImageUrl != null ? `${baseUrlPathImage.test}/${dataQuestion?.choice?.choiceCImageUrl}`:null,
    choiceDImageUrl:dataQuestion?.choice?.choiceDImageUrl != null ? `${baseUrlPathImage.test}/${dataQuestion?.choice?.choiceDImageUrl}`:null,
    choiceEImageUrl:dataQuestion?.choice?.choiceEImageUrl != null ? `${baseUrlPathImage.test}/${dataQuestion?.choice?.choiceEImageUrl}`:null,
  });
  const [input, setInput] = useState(() => ({
  ...(dataQuestion?.id && { id: dataQuestion.id }), // add id only if updating
  questionText: dataQuestion?.questionText || "",
  answerKey: dataQuestion?.answerKey || "",
  levelId: dataQuestion?.levelId || "",
  categoryId: dataQuestion?.categoryId || "",
  subCategoryId:dataQuestion?.subCategoryId || "",
  questionImageUrl:dataQuestion?.questionImageUrl,
  a: dataQuestion?.choice?.a || "",
  b: dataQuestion?.choice?.b || "",
  c: dataQuestion?.choice?.c || "",
  d: dataQuestion?.choice?.d || "",
  e: dataQuestion?.choice?.e || "",
  answerKeyImage:null as File | null,
  questionImage: null as File | null,
  choiceAImage: null as File | null,
  choiceBImage: null as File | null,
  choiceCImage: null as File | null,
  choiceDImage: null as File | null,
  choiceEImage: null as File | null,

}));
const handleUserInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
  const { name, value,type } = e.target;
  // Handle file input
  if (type === "file" && e.target instanceof HTMLInputElement && e.target.files) {
    const file = e.target.files[0];
    setInput(prev => ({
      ...prev,
      [name]: file // store the File object
    }));
    return;
  }
  let processedValue: any = value;
  // convert to number if departmentId or positionId
  if (name === "categoryId" || name === "subCategoryId") {
    //console.log(input.categoryId);
    processedValue = Number(value);
  }
  setInput((prev) => ({
    ...prev,
    [name]: processedValue
  }));
};

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) =>{
    e.preventDefault();
      if (loading) return; // Prevent multiple clicks
    setLoading(true);
      try {
  const formData = new FormData();
 
  if(input.id != null){
    formData.append("id", input.id.toString())
  }
  formData.append("categoryId", input.categoryId.toString());
  formData.append("subCategoryId", input.subCategoryId.toString());
  formData.append("questionText", input.questionText);
  formData.append("levelId", input.levelId.toString());
  formData.append("answerKey", input.answerKey.toString());

  if(getImageUrl.questionImageUrl == null){
    formData.append("questionImageUrlDelete", true.toString());
  }

  if(input.a)
    {formData.append("a", input.a.toString());}
  if(input.b)
    {formData.append("b", input.b.toString());}
  if(input.c)
    {formData.append("c", input.c.toString());}
  if(input.d)
    {formData.append("d", input.d.toString());}
  if(input.e)
    {formData.append("e", input.e.toString());}

if (input.answerKeyImage) {
    formData.append("answerKeyImage", input.answerKeyImage);
  }
  if (input.questionImage) {
    formData.append("questionImage", input.questionImage);
  }
  if (input.choiceAImage) {
    formData.append("choiceAImage", input.choiceAImage);
  }    
  if (input.choiceBImage) {
    formData.append("choiceBImage", input.choiceBImage);
  } 
    if (input.choiceCImage) {
    formData.append("choiceCImage", input.choiceCImage);
  }    
  if (input.choiceDImage) {
    formData.append("choiceDImage", input.choiceDImage);
  }     
   if (input.choiceEImage) {
    formData.append("choiceEImage", input.choiceEImage);
  }       
             
    const response:QApiResponse = 
    input.id != undefined ? await updateQuestion(formData).unwrap()
    : await addQuestion(formData).unwrap();
  
    //console.log(response);
    if(response.isSuccess == true){
            toast.success(getToast+' Successfully!', {
                position: "top-right", 
                autoClose: 5000, 
              });
        navigate("/questions/list");
        }else if(response.exist == true){
          toast.error('Question already exist!', {
            position: "top-right", 
            autoClose: 5000, 
          });
        }
        else{
          toast.error( response?.errorMessages?.[0],{
              position: "top-right", 
              autoClose: 5000, 
            });
        }
      
    } catch (error) {
      console.error('Error:', error);
     
    } finally {
      setLoading(false);
    }



    }
   
    //console.log(dataQuestion);
    useEffect(() => {
      if (!dataQuestion) {
        setGetToast("Created");
      } else {
        setGetToast("Updated");
      }
    }, [dataQuestion]);
  return (
    <div>
         <form onSubmit={handleSubmit}>
                <div className="form-group">
                   
                  <label htmlFor="serviceTypeName" className="col-form-label">Question</label>
                  <textarea className="form-control" 
                  required
                  name='questionText'
                  value={input.questionText}
                  onChange={handleUserInput}
                  >
                  </textarea>
                  <label>Question Image:</label>
                  <input type="file" name="questionImage" onChange={handleUserInput} />
                  <>
                 
                  </>
                {input.questionImage ? (
                  <><a href="#" onClick={() => handleImageDelete()}>
                    <i className="bi bi-trash"></i>
                  </a><img
                  src={URL.createObjectURL(input.questionImage)}
                  alt="Preview"
                  width={200} /></>) 
                  : 
                  dataQuestion?.questionImageUrl && (
                  <>
                  <a href="#" onClick={() => handleImageUrlDelete()}>
                    <i className="bi bi-trash"></i>
                  </a>
                  <img src={getImageUrl.questionImageUrl ?? undefined} alt="Question" width="200"/>
                  </>)
                }

                  <label htmlFor="answerKeyImage" className="col-form-label">Answer Key</label>
                  <input type="text" className="form-control" 
                   required={input.answerKeyImage == null && getImageUrl.answerKeyImageUrl == null} 
                   name='answerKey'
                   value={input.answerKey}
                   onChange={handleUserInput}
                  />
                   <label>Answer Key Image:</label>
                  <input type="file" name="answerKeyImage" onChange={handleUserInput} />
                   {input.answerKeyImage ? (
                    <img
                      src={URL.createObjectURL(input.answerKeyImage)}
                      alt="Preview"
                      width={200}
                    />) :dataQuestion?.answerKeyImageUrl && (
                      <img src={getImageUrl.answerKeyImageUrl ?? undefined} alt="answerKeyImageUrl" width="200" 
                    />
                  )}
                
                   <label htmlFor="recipient-name" className="col-form-label">Select Category</label>
                    <select
                          required
                          className="form-group form-select"
                          name='categoryId'
                          value={input.categoryId}
                          onChange={handleUserInput}
                        >
                          <option value="">-=Categories=-</option>
                          {categories?.map((option: any, index: number) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                    </select>

                     <label htmlFor="recipient-name" className="col-form-label">Select Sub Category</label>
                    <select
                          required
                          className="form-group form-select"
                          name='subCategoryId'
                          value={input.subCategoryId}
                          onChange={handleUserInput}
                        >
                        <option value="">-=Sub Categories=-</option>
                         {categories
                            .find((d) => d.id == input.categoryId) // 🔹 get the selected department
                            ?.subCategory?.map((option) => (      // 🔹 map its positions
                                <option key={option.id} value={option.id}>
                                {option.subCategoryName}
                                </option>
                            ))}
                    </select>
                    <label htmlFor="recipient-name" className="col-form-label">Select Level</label>
                    <select
                          required
                          className="form-group form-select"
                          name='levelId'
                          value={input.levelId}
                          onChange={handleUserInput}
                        >
                          <option value="">-=Level=-</option>
                            <option key={1} value={1}>
                              Easy
                            </option>
                             <option key={2} value={2}>
                              Medium
                            </option>
                             <option key={3} value={3}>
                              Hard
                            </option>
                            
                    </select>

                    <label htmlFor="a" className="col-form-label">Choice 1</label>
                    <input type="text" className="form-control" 
                    required ={input.choiceAImage == null && getImageUrl.choiceAImageUrl == null}
                    name='a'
                    value={input?.a}
                    onChange={handleUserInput}
                  />
                  <label>Choice 1 Url:</label>
                  <input type="file" name="choiceAImage" onChange={handleUserInput} />
               
                   {input.choiceAImage ? (
                    <img
                      src={URL.createObjectURL(input.choiceAImage)}
                      alt="Preview"
                      width={200}
                    />) : dataQuestion?.choice?.choiceAImageUrl != "" && (
                      <img src={getImageUrl.choiceAImageUrl ?? undefined} alt="choiceAImageUrl" width="200" 
                    />
                  )}

                    <label htmlFor="b" className="col-form-label">Choice 2</label>
                    <input type="text" className="form-control" 
                      required ={input.choiceBImage == null && getImageUrl.choiceBImageUrl == null}
                    name='b'
                    value={input?.b}
                    onChange={handleUserInput}
                  />
                    <label>Choice 2 Url:</label>
                  <input type="file" name="choiceBImage" onChange={handleUserInput} />
                    {input.choiceBImage ? (
                    <img
                      src={URL.createObjectURL(input.choiceBImage)}
                      alt="Preview"
                      width={200}
                    />) : dataQuestion?.choice?.choiceBImageUrl != "" &&(
                      <img src={getImageUrl.choiceBImageUrl ?? undefined} alt="choiceBImageUrl" width="200" 
                    />
                  )}
                    <label htmlFor="c" className="col-form-label">Choice 3</label>
                    <input type="text" className="form-control" 
                     required ={input.choiceCImage == null && getImageUrl.choiceCImageUrl == null}
                    name='c'
                    value={input?.c}
                    onChange={handleUserInput}
                  />
                     <label>Choice 3 Url:</label>
                  <input type="file" name="choiceCImage" onChange={handleUserInput} />
                    {input.choiceCImage ? (
                    <img
                      src={URL.createObjectURL(input.choiceCImage)}
                      alt="Preview"
                      width={200}
                    />) : dataQuestion?.choice?.choiceCImageUrl != "" && (
                      <img src={getImageUrl.choiceCImageUrl ?? undefined} alt="choiceCImageUrl" width="200" 
                    />
                  )}
                    <label htmlFor="d" className="col-form-label">Choice 4</label>
                    <input type="text" className="form-control" 
                    
                    name='d'
                    value={input?.d}
                    onChange={handleUserInput}
                  />
                     <label>Choice 4 Url:</label>
                  <input type="file" name="choiceDImage" onChange={handleUserInput} />
                    {input.choiceDImage ? (
                    <img
                      src={URL.createObjectURL(input.choiceDImage)}
                      alt="Preview"
                      width={200}
                    />) : dataQuestion?.choice?.choiceDImageUrl != "" && (
                      <img src={getImageUrl.choiceDImageUrl ?? undefined} alt="choiceDImageUrl" width="200" 
                    />
                  )}
                    <label htmlFor="e" className="col-form-label">Choice 5</label>
                    <input type="text" className="form-control" 
                   
                    name='e'
                    value={input?.e}
                    onChange={handleUserInput}
                  />
               <label>Choice 5 Url:</label>
                <input type="file" name="choiceEImage" onChange={handleUserInput} />
                 {input.choiceEImage ? (
                    <img
                      src={URL.createObjectURL(input.choiceEImage)}
                      alt="Preview"
                      width={200}
                    />) : dataQuestion?.choice?.choiceEImageUrl != "" && (
                      <img src={getImageUrl.choiceEImageUrl ?? undefined} alt="choiceEImageUrl" width="200" 
                    />
                  )}
                 {
                 <button type="submit" className="btn btn-primary" disabled={loading}>Submit</button>
                  
              }{
                loading && <Loader/>
              }
            </div>
            </form>
    </div>
  )
}

export default QuestionEdit